(function () {
    'use strict';

    angular.module("imApp").factory("requisitionService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 762,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1356,
                    parameters: edit
                });
            },
            cancelItem: function (edit) {
                return $ihttp.post({
                    method: 1093,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 763,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
